import { Link } from 'wouter';
import { ArrowRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Eyebrow, Section, SectionTitle, cardClass } from './layout';

/** Primary "start free trial" pill (→ /register) plus an optional secondary anchor. */
export function TrialButtons({ cta, secondary, secondaryHref = '#features' }: { cta: string; secondary?: string; secondaryHref?: string }) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row">
      <Link
        href="/register"
        className="inline-flex h-14 items-center justify-center gap-2 rounded-pill bg-brand-500 px-7 text-[15px] font-semibold text-white transition-colors hover:bg-brand-700"
      >
        {cta}
        <ArrowRight className="h-4 w-4" aria-hidden="true" />
      </Link>
      {secondary && (
        <a
          href={secondaryHref}
          className="inline-flex h-14 items-center justify-center rounded-pill border border-line bg-surface px-7 text-[15px] font-semibold text-ink transition-colors hover:border-brand-300 hover:text-brand-700"
        >
          {secondary}
        </a>
      )}
    </div>
  );
}

/** Compact pricing card linking to /pricing, used by the public (non-invite) landing pages. */
export function PricingBand({ eyebrow, title, subtitle, cta, className = 'bg-brand-50' }: {
  eyebrow: string;
  title: string;
  subtitle: string;
  cta: string;
  className?: string;
}) {
  return (
    <Section className={className}>
      <div className={cn(cardClass, 'flex flex-col gap-6 p-7 lg:flex-row lg:items-center lg:gap-10 lg:p-12')}>
        <div className="flex flex-1 flex-col gap-3">
          <Eyebrow>{eyebrow}</Eyebrow>
          <SectionTitle>{title}</SectionTitle>
          <p className="m-0 text-base leading-[1.6] text-soft lg:text-lg">{subtitle}</p>
        </div>
        <Link
          href="/pricing"
          className="inline-flex h-14 items-center justify-center gap-2 rounded-pill border border-line bg-surface px-7 text-[15px] font-semibold text-ink transition-colors hover:border-brand-300 hover:text-brand-700"
        >
          {cta}
          <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </Link>
      </div>
    </Section>
  );
}
